export default {
  th_th: {
    bannerImg: 'th.png',
    umText: 'กำลังมา เร็วๆนี้',
    requiredLogin: 'เกมส์นี้ต้องเข้าระบบ',
    jackpotId_1: {
      name: 'แจ๊คพ็อตขุมทรัพย์เทพนิยาย',
      level1Jackpot: 'แกรนด์',
      level2Jackpot: 'เมกะ',
      level3Jackpot: 'เมเจอร์'
    },
    jackpotId_2: {
      name: 'แจ็คพอต ขนปุย',
      level1Jackpot: 'เมก้า',
      level2Jackpot: 'แม็กซี่',
      level3Jackpot: 'มินิ'
    },
    jackpotId_3: {
      name: 'โกลเด้น ริช แจ็คพอต',
      level1Jackpot: 'แกรนด์',
      level2Jackpot: 'เมเจอร์',
      level3Jackpot: 'ไมเนอร์',
      level4Jackpot: 'มินิ',
    }
  },
};



